/**
 * Returns the next limit step.
 * @param {number} limit
 * @returns {number} Next Limit
 */
export const getNextLimit = limit => {
  switch (limit) {
    case 36:
      return 72

    case 72:
      return 96

    case 96:
      return 36

    default:
      return 36
  }
}
